import React, { forwardRef } from "react";
import { LayoutStyle, FormHeader, FormBody } from "./styles";
import CardLayoutField from "./CardLayoutField";

export interface CardLayoutContainerProps
  extends React.HTMLAttributes<HTMLDivElement> {
  header?: {
    title: string;
    description?: React.ReactNode;
  };
  width?: number;
  /** children 요소 간의 간격 (px 단위) */
  gap?: number;
  bodyStyle?: React.CSSProperties;
  headerColor?: string;
}

const CardLayoutContainer = forwardRef<
  HTMLDivElement,
  CardLayoutContainerProps
>(({ header, children, gap, bodyStyle, headerColor, ...rest }, ref) => {
  return (
    <LayoutStyle {...rest} ref={ref}>
      {header && (
        <FormHeader>
          <h1 style={{ color: headerColor ?? undefined }}>{header.title}</h1>
          <p>{header.description}</p>
        </FormHeader>
      )}
      <FormBody gap={gap} style={bodyStyle}>
        {children}
      </FormBody>
    </LayoutStyle>
  );
});
CardLayoutContainer.displayName = "CardLayoutContainer";

export default {
  Container: CardLayoutContainer,
  Field: CardLayoutField,
};
